var map = {
	"./close.svg": 39027,
	"./delete-icon.svg": 58226,
	"./error-icon.svg": 83149,
	"./loading.svg": 64271,
	"./message_quote.svg": 31059,
	"./open-in-new-icon.svg": 20112,
	"./search-icon.svg": 42621,
	"./search.svg": 36857,
	"./send-icon.svg": 77651,
	"./send-small-icon.svg": 81665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70667;